const styles = `:host {
  --goto-icon-size: 48px;
  display: flex;
}
:host .old-logo-container {
  display: flex;
  align-items: center;
}
:host .rebranding-logo-container {
  display: none;
}

:host(.rebranding) .old-logo-container {
  display: none;
}
:host(.rebranding) .rebranding-logo-container {
  display: flex;
  align-items: center;
}`; export default styles;